/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_timer_u30m_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thirty minutes is generally enough time to cover one clear agenda item without leaving so much open time that the discussion drifts. It also fits cleanly into a calendar with back-to-back meetings, which is a practical reason it became a default length.`)
};

const es_timer_u30m_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Treinta minutos generalmente es tiempo suficiente para cubrir un punto claro de la agenda sin dejar tanto tiempo libre como para que la discusión se disperse. También encaja perfectamente en una agenda con reuniones consecutivas, lo cual es una razón práctica por la que se convirtió en una duración predeterminada.`)
};

const de_timer_u30m_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dreißig Minuten reichen meist, um einen klaren Tagesordnungspunkt zu behandeln, ohne so viel offene Zeit zu lassen, dass die Diskussion abdriftet. Es passt außerdem sauber in einen Kalender mit aufeinanderfolgenden Meetings — ein praktischer Grund, warum es zur Standardlänge wurde.`)
};

const nl_timer_u30m_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dertig minuten is over het algemeen genoeg tijd om één duidelijk agendapunt te behandelen zonder zoveel open tijd over te laten dat de discussie afdwaalt. Het past ook netjes in een agenda met aaneengesloten vergaderingen, wat een praktische reden is waarom het een standaardlengte werd.`)
};

const fr_timer_u30m_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trente minutes suffisent généralement pour traiter un point d’ordre du jour clair, sans laisser trop de temps libre qui ferait dériver la discussion. Cela s’intègre aussi facilement dans un agenda avec des réunions enchaînées, ce qui explique en partie pourquoi c’est devenu une durée par défaut.`)
};

const it_timer_u30m_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trenta minuti sono generalmente abbastanza per trattare un singolo punto chiaro dell'ordine del giorno senza lasciare così tanto tempo libero che la discussione si disperda. Si adatta anche perfettamente a un calendario con riunioni consecutive, il che è una ragione pratica per cui è diventata una durata predefinita.`)
};

const pt_br2_timer_u30m_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trinta minutos geralmente são suficientes para cobrir um item claro de pauta sem deixar tanto tempo livre que a discussão se disperse. Também se encaixa bem em uma agenda com reuniões consecutivas, o que é uma razão prática para essa ter se tornado uma duração padrão.`)
};

const pt_timer_u30m_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trinta minutos são geralmente tempo suficiente para cobrir um item claro da agenda sem deixar tanto tempo livre que a discussão se disperse. Também encaixa de forma limpa numa agenda com reuniões consecutivas, o que é uma razão prática pela qual se tornou uma duração predefinida.`)
};

const ja_timer_u30m_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`30分は、1つの明確な議題を扱うのに十分な時間でありながら、議論が脱線するほど余裕のある時間ではありません。また連続するミーティングのスケジュールにもきれいに収まるため、これがデフォルトの長さとして定着した実用的な理由でもあります。`)
};

const zh_timer_u30m_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`三十分钟通常足够处理一个明确的议程事项，又不会留出太多空余时间导致讨论跑题。它也能很好地嵌入连续排满的日程安排中，这也是它成为默认会议时长的实际原因。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const timer_u30m_faq4_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.timer_u30m_faq4_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("timer_u30m_faq4_a", locale)
	if (locale === "en") return en_timer_u30m_faq4_a(inputs)
	if (locale === "es") return es_timer_u30m_faq4_a(inputs)
	if (locale === "de") return de_timer_u30m_faq4_a(inputs)
	if (locale === "nl") return nl_timer_u30m_faq4_a(inputs)
	if (locale === "fr") return fr_timer_u30m_faq4_a(inputs)
	if (locale === "it") return it_timer_u30m_faq4_a(inputs)
	if (locale === "pt-BR") return pt_br2_timer_u30m_faq4_a(inputs)
	if (locale === "pt") return pt_timer_u30m_faq4_a(inputs)
	if (locale === "ja") return ja_timer_u30m_faq4_a(inputs)
	return zh_timer_u30m_faq4_a(inputs)
};